import { initializeImg } from '@src/telemetry/integrations/provider-utils/initialize-img'
import type { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

export let getImgSrc: (type: string, eventId: number) => string

const EVENT_IDS = {
  ADD_TO_CART: 51556,
  ALL_PAGES: 51555,
}

export const Claritas: TelemetryIntegration = {
  initialize: () => {
    const randomOrd = Math.random() * 10000000000000
    getImgSrc = (type: string, eventId: number) =>
      `${TELEMETRY_DOMAINS.CLARITAS}/pixel/conv/ppt=22167;g=${type};gid=${eventId};ord=${randomOrd};v=120`
  },

  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.CLARITAS,
  },
  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: () => {
      initializeImg({
        id: `claritas_all_pages`,
        src: getImgSrc('all_pages', EVENT_IDS.ALL_PAGES),
        width: '1',
        height: '1',
      })
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: () => {
      initializeImg({
        id: `claritas_add_to_cart`,
        src: getImgSrc('add_to_cart', EVENT_IDS.ADD_TO_CART),
        width: '1',
        height: '1',
      })
    },
  },
}
